import Vue from 'vue';

export default {
    SET_REASONS: (state, reasons) => {
        state.reasons = reasons;
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = {
            page: pagination.page || state.pagination.page,
            totalPages: pagination.totalPages || state.pagination.page
        };
    },

    SET_REASON_TYPE: (state) => {   
        state.reasons.type.push({});
    },

    ADD_REASON: (state, reason) => {
        state.reasons.unshift(reason);
    },

    DELETE_REASON: (state, reason) => {
        state.reasons = state.reasons.filter(it => it.id !== reason.id);
    },

    EDIT_REASON: (state, reason) => {
        const index = state.reasons.findIndex(it => it.id == reason.id);
        Vue.set(state.reasons, index, reason);
    }
};
